import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

function Upcoming() {
  const [upcomingData, setUpcomingData] = useState([]);
  const [type, setType] = useState("/movie/top_rated");
  const api_key = "1c349502ffa6fe67721a2ea4260bed9f";
  const api_url = "https://api.themoviedb.org/3/";
  const getResponseData = async () => {
    const data = await fetch(
      `${api_url}/${type}?api_key=${api_key}&language=en-US&page=1`
    );
    const response = await data.json();
    console.log("res", response.results);
    setUpcomingData(response.results);
  };
  useEffect(() => {
    getResponseData();
  }, [type]);
  return (
    <>
      <section className="upcoming">
        <div className="container">
          <div className="flex-wrapper">
            <div className="title-wrapper">
              <p className="section-subtitle">Online Streaming</p>

              <h2 className="h2 section-title">
                {type === "/movie/top_rated" && "Top Rated Movies"}
                {type === "/tv/top_rated" && "Top TV Shows"}
                {type === "/discover/movie" && "Discover movies"}
              </h2>
            </div>

            <ul className="filter-list">
              <li>
                <button
                  onClick={() => setType("/movie/top_rated")}
                  className="filter-btn"
                >
                  Movies
                </button>
              </li>

              <li>
                <button
                  onClick={() => setType("/tv/top_rated")}
                  className="filter-btn"
                >
                  TV SHOW
                </button>
              </li>

              <li>
                <button
                  onClick={() => setType("/discover/movie")}
                  className="filter-btn"
                >
                  Discover
                </button>
              </li>
            </ul>
          </div>

          <ul className="movies-list has-scrollbar">
            {upcomingData.map((item) => (
              <li>
                <div className="movie-card">
                  <Link
                    to={
                      type.includes("movie")
                        ? `/details/movie/${item.id}`
                        : `/details/tv/${item.id}`
                    }
                  >
                    <figure class="card-banner">
                      <img
                        src={`https://image.tmdb.org/t/p/w500/${item.poster_path}`}
                        alt="The Unbearable Weight of Massive Talent movie poster"
                      />
                    </figure>
                  </Link>

                  <div className="title-wrapper">
                    <Link to={"/movie-details/" + item.id}>
                      <h3 className="card-title">
                        {type.includes("movie") ? item.title : item.name}
                      </h3>
                    </Link>

                    <time datetime="2022">
                      {type.includes("movie")
                        ? item.release_date
                        : item.first_air_date}
                    </time>
                  </div>

                  <div className="card-meta">
                    <div className="badge badge-outline">
                      {item.original_language}
                    </div>

                    {/* <div className="duration">
                      <ion-icon name="time-outline"></ion-icon>

                      <time datetime="PT137M">{item.time}</time>
                    </div> */}

                    <div className="rating">
                      <ion-icon name="star"></ion-icon>

                      <data>{item.vote_average}</data>
                    </div>
                  </div>
                </div>
              </li>
            ))}
          </ul>
        </div>
      </section>
    </>
  );
}

export default Upcoming;
